import api from "../api/api";
import {
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  LogoutResponse,
  ApiResponse,
  GeneralInviteResponse,
} from "../types/auth";

export const login = async (
  credentials: LoginRequest
): Promise<LoginResponse> => {
  const response = await api.post<ApiResponse<LoginResponse>>(
    "/api/Auth/login",
    credentials
  );
  return response.data.payload;
};

export const logout = async (
  request: LogoutRequest
): Promise<LogoutResponse> => {
  const response = await api.post<ApiResponse<LogoutResponse>>(
    "/api/Auth/logout",
    request
  );
  return response.data.payload;
};

export const generalInvite = async (
  individualId: string
): Promise<GeneralInviteResponse> => {
  const response = await api.post<GeneralInviteResponse>(
    `/api/Auth/general-invite/${individualId}`
  );
  return response.data;
};
